export enum DiscussionItemType {
  business = 'Business',
  partner = 'Partner',
  selfResponse = 'SelfResponse'
}